var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 20,
    viewBox: "0 0 84 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69636 1.70711C2.0664 1.07714 2.51257 0 3.40347 0H10.575C10.8403 0 11.0946 0.105357 11.2822 0.292893L20.2822 9.29289C20.6727 9.68342 20.6727 10.3166 20.2822 10.7071L11.2822 19.7071C11.0946 19.8946 10.8403 20 10.575 20H3.40347C2.51257 20 2.0664 18.9229 2.69636 18.2929L10.2822 10.7071C10.6727 10.3166 10.6727 9.68342 10.2822 9.29289L2.69636 1.70711Z",
    fill: "#D183E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6964 1.70711C23.0664 1.07714 23.5126 0 24.4035 0H31.575C31.8403 0 32.0946 0.105357 32.2822 0.292893L41.2822 9.29289C41.6727 9.68342 41.6727 10.3166 41.2822 10.7071L32.2822 19.7071C32.0946 19.8946 31.8403 20 31.575 20H24.4035C23.5126 20 23.0664 18.9229 23.6964 18.2929L31.2822 10.7071C31.6727 10.3166 31.6727 9.68342 31.2822 9.29289L23.6964 1.70711Z",
    fill: "#D183E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6964 1.70711C44.0664 1.07714 44.5126 0 45.4035 0H52.575C52.8403 0 53.0946 0.105357 53.2822 0.292893L62.2822 9.29289C62.6727 9.68342 62.6727 10.3166 62.2822 10.7071L53.2822 19.7071C53.0946 19.8946 52.8403 20 52.575 20H45.4035C44.5126 20 44.0664 18.9229 44.6964 18.2929L52.2822 10.7071C52.6727 10.3166 52.6727 9.68342 52.2822 9.29289L44.6964 1.70711Z",
    fill: "#D183E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6964 1.70711C65.0664 1.07714 65.5126 0 66.4035 0H73.575C73.8403 0 74.0946 0.105357 74.2822 0.292893L83.2822 9.29289C83.6727 9.68342 83.6727 10.3166 83.2822 10.7071L74.2822 19.7071C74.0946 19.8946 73.8403 20 73.575 20H66.4035C65.5126 20 65.0664 18.9229 65.6964 18.2929L73.2822 10.7071C73.6727 10.3166 73.6727 9.68342 73.2822 9.29289L65.6964 1.70711Z",
    fill: "#D183E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.59751ef7b022cacd7807a799298eef69.svg";
export { ForwardRef as ReactComponent };